import React from 'react'
import { Link } from 'gatsby'

import './Footer.css'
import links from '@data/links.json'

import icon from './xelex-icon--color.svg'

const Footer = () => (
  <footer className='c-footer'>
    <div className='l-container c-footer__container'>
      <nav className='c-footer-nav'>
        <div className='c-footer-nav__col'>
          <span className='text-lg font-semibold mb-1'>Explore</span>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.home}
          >
            Home
          </Link>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.services}
          >
            Services
          </Link>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.useCases}
          >
            Use Cases
          </Link>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.platform}
          >
            Platform
          </Link>
        </div>

        <div className='c-footer-nav__col'>
          <span className='text-lg font-semibold mb-1'>More</span>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.about}
          >
            About
          </Link>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.login}
          >
            Login
          </Link>
          <Link
            className='c-footer-nav__link transition-colors'
            to={links.contact}
          >
            Get in Touch
          </Link>
        </div>

        <div className='c-footer-nav__col col-span-full lg:col-auto'>
          <span className='text-lg font-semibold mb-1'>Sales</span>
          <div className='flex'>
            <div className='flex flex-col mr-5'>
              <a
                className='font-semibold text-brand-primary hover:text-brand-secondary transition-colors'
                href='mailto:info@xelex.ai'
              >
                info@xelex.ai
              </a>
              <span className='font-semibold text-brand-medium'>
                877-757-4640 x 1
              </span>
            </div>
          </div>

          <span className='text-lg font-semibold mb-1 mt-3'>Support</span>
          <div className='flex'>
            <div className='flex flex-col mr-5'>
              <a
                className='font-semibold text-brand-primary hover:text-brand-secondary transition-colors'
                href='mailto:info@xelex.ai'
              >
                support@xelex.ai
              </a>
              <span className='font-semibold text-brand-medium'>
                877-757-4640 x 2
              </span>
            </div>
          </div>
        </div>
      </nav>

      <div className='c-footer__brand'>
        <img src={icon} alt='Xelex Icon' />
        <div className='mt-8'>
          <span>&copy; {new Date().getFullYear()} Xelex Inc.</span>
          <span className='text-xs inline-block mx-3'>&middot;</span>
          <Link
            to={links.privacy}
            className='hover:text-brand-primary transition-colors'
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
